var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2805)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_2805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.33 0H3.57C1.59834 0 0 1.59834 0 3.57V20.33C0 22.3017 1.59834 23.9 3.57 23.9H20.33C22.3017 23.9 23.9 22.3017 23.9 20.33V3.57C23.9 1.59834 22.3017 0 20.33 0Z",
    fill: "#F28629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.66 0.969971H4.24997C2.43848 0.969971 0.969971 2.43848 0.969971 4.24997V19.66C0.969971 21.4715 2.43848 22.94 4.24997 22.94H19.66C21.4715 22.94 22.94 21.4715 22.94 19.66V4.24997C22.94 2.43848 21.4715 0.969971 19.66 0.969971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.22 1.57996H4.68002C2.96793 1.57996 1.58002 2.96787 1.58002 4.67996V19.22C1.58002 20.932 2.96793 22.32 4.68002 22.32H19.22C20.9321 22.32 22.32 20.932 22.32 19.22V4.67996C22.32 2.96787 20.9321 1.57996 19.22 1.57996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.64 2.40002H5.26002C3.68049 2.40002 2.40002 3.68049 2.40002 5.26002V18.64C2.40002 20.2196 3.68049 21.5 5.26002 21.5H18.64C20.2196 21.5 21.5 20.2196 21.5 18.64V5.26002C21.5 3.68049 20.2196 2.40002 18.64 2.40002Z",
    fill: "#0A3B87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.03 3.28003H5.87003C4.43961 3.28003 3.28003 4.43961 3.28003 5.87003V18.03C3.28003 19.4604 4.43961 20.62 5.87003 20.62H18.03C19.4604 20.62 20.62 19.4604 20.62 18.03V5.87003C20.62 4.43961 19.4604 3.28003 18.03 3.28003Z",
    fill: "#0A2C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31 20.59H15.99L11.56 12.34C11.13 11.54 10.18 11.54 9.74 12.34L5.31 20.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.32 20.59H19.03L16.66 16.18C16.43 15.75 15.92 15.75 15.69 16.18L13.32 20.59Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.73 4.12H13.8C13.2201 4.12 12.75 4.5901 12.75 5.17V10.1C12.75 10.6799 13.2201 11.15 13.8 11.15H18.73C19.3099 11.15 19.78 10.6799 19.78 10.1V5.17C19.78 4.5901 19.3099 4.12 18.73 4.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.43 4.54004H14.1C13.5864 4.54004 13.17 4.95641 13.17 5.47004V9.80004C13.17 10.3137 13.5864 10.73 14.1 10.73H18.43C18.9436 10.73 19.36 10.3137 19.36 9.80004V5.47004C19.36 4.95641 18.9436 4.54004 18.43 4.54004Z",
    fill: "#F4821F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.83 5.4C14.92 5.39 15 5.38 15.08 5.37C15.16 5.37 15.25 5.37 15.34 5.37C15.42 5.37 15.5 5.37 15.58 5.37C15.66 5.37 15.75 5.39 15.84 5.4L17.24 9.87C17.07 9.9 16.91 9.91 16.74 9.91C16.57 9.91 16.43 9.9 16.28 9.87L16.03 8.97999H14.55L14.3 9.87C14.15 9.9 14.01 9.91 13.87 9.91C13.72 9.91 13.57 9.9 13.42 9.87L14.83 5.4ZM15.31 6.35L14.77 8.22999H15.83L15.31 6.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 5.39999C17.91 5.37999 18.06 5.35999 18.2 5.35999C18.35 5.35999 18.51 5.36999 18.66 5.39999V9.86999C18.51 9.89999 18.36 9.90999 18.21 9.90999C18.06 9.90999 17.91 9.89999 17.75 9.86999V5.39999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46999 10.7C8.46999 10.7 8.35999 10.66 8.30999 10.7L7.83999 11.17L7.23999 10.57C7.23999 10.57 7.12999 10.53 7.07999 10.57C7.03999 10.61 7.03999 10.68 7.07999 10.73L7.67999 11.33L7.83999 11.49L7.99999 11.33L8.46999 10.86C8.46999 10.86 8.50999 10.75 8.46999 10.7Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51003 8.59004C7.51003 8.59004 7.40003 8.55004 7.35003 8.59004L6.88003 9.06004L6.28003 8.46004C6.28003 8.46004 6.17003 8.42004 6.12003 8.46004C6.08003 8.50004 6.08003 8.57004 6.12003 8.62004L6.72003 9.22004L6.88003 9.38004L7.04003 9.22004L7.51003 8.75004C7.51003 8.75004 7.55003 8.64004 7.51003 8.59004Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36 9.53999C5.36 9.53999 5.25 9.49999 5.2 9.53999L4.73 10.01L4.13 9.40999C4.13 9.40999 4.02 9.36999 3.97 9.40999C3.93 9.44999 3.93 9.51999 3.97 9.56999L4.57 10.17L4.73 10.33L4.89 10.17L5.36 9.69999C5.36 9.69999 5.4 9.58999 5.36 9.53999Z",
    fill: "#F1F2F2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_2805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9,
    height: 23.9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAi);
export default __webpack_public_path__ + "static/media/image-AI.6348d569e73b92cc2e3937d94d5bb2a6.svg";
export { ForwardRef as ReactComponent };